import React, { useEffect, useState } from "react";
import './setting.css'
import Sidebox from "./SideBox";
import { useSelector } from "react-redux";
import { toggleTheme } from "../../../../Redux/reducers/themeReducer";
import { FiSunrise } from "react-icons/fi";
import { useDispatch } from "react-redux";

const ThemeSetting = () => {
    const theme = useSelector((state) => state.theme.mode);
    const dispatch = useDispatch()
    useEffect(() => {
        document.body.classList.toggle("dark-theme", theme === "dark");
    }, [theme]);
    useEffect(() => {
        if (theme === "dark") {
            document.body.classList.add("dark-theme");
        } else {
            document.body.classList.remove("dark-theme");
        }
        console.log("Body class list:", document.body.classList); // Debugging
    }, [theme]);

    return (
        <div className='container'>
            <div className='pading-space pt-5'>
                <div className="pt-5 pb-5">
                    <div className="row">
                        <div className="col-3 pt-5"><Sidebox /></div>
                        <div className="col-9  px-5">

                            <div onClick={() => dispatch(toggleTheme())} className="pb-4">

                                <div className='iconBG' ><FiSunrise /></div>
                                <span className="settingtext">Dark Mode</span> </div>
                       
                        </div>
                    </div>
                </div >
            </div>
        </div>
    );
}
export default ThemeSetting;